export default (url: string) => url.split('?')[0];
